import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EmailPreviewDevice } from 'src/app/models/communication/email-html-import';

interface DeviceOption {
	label: string;
	value: EmailPreviewDevice;
	icon: string;
}

@Component({
	selector: 'app-email-preview-frame',
	templateUrl: './email-preview-frame.component.html',
	styleUrls: ['./email-preview-frame.component.scss']
})
export class EmailPreviewFrameComponent implements OnChanges {
	@Input() html: string = '';
	@Input() device: EmailPreviewDevice = 'desktop';
	@Input() showDeviceToggle: boolean = true;

	@Output() deviceChange = new EventEmitter<EmailPreviewDevice>();

	public readonly deviceOptions: DeviceOption[] = [
		{ label: 'Desktop', value: 'desktop', icon: 'pi pi-desktop' },
		{ label: 'Mobile', value: 'mobile', icon: 'pi pi-mobile' }
	];

	/** Built once per `html` change so the iframe only reloads when the content actually changes. */
	public safeHtml: SafeHtml = null;
	public isEmpty: boolean = true;

	constructor(private sanitizer: DomSanitizer) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['html']) {
			this.isEmpty = !this.html || !this.html.trim();
			// Trusted only because the iframe is fully sandboxed (sandbox="" — no scripts, no same-origin,
			// no forms, no popups). Never bind this value anywhere else.
			this.safeHtml = this.isEmpty ? null : this.sanitizer.bypassSecurityTrustHtml(this.html);
		}
	}

	public setDevice(device: EmailPreviewDevice): void {
		if (!device || device === this.device) {
			return;
		}
		this.device = device;
		this.deviceChange.emit(device);
	}
}
